var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',_vm._g(_vm._b({attrs:{"type":"index","label":"序号","width":"60","align":"center","fixed":""}},'el-table-column',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }